import { useMutation } from "@tanstack/react-query";
import api from "@/services/api";
import type { SampleClassifyRequest, SampleClassifyResponse } from "@/types";

/**
 * RoMSH 라이브 테스터용 뮤테이션 훅.
 *
 * POST /sample/classify — 단건 혼합물 분류 (인하대 트랜스포머).
 * 라이브 테스트 시 sample_id=null (더미)로 호출 가능.
 */
export function useClassifySample() {
  return useMutation<SampleClassifyResponse, Error, SampleClassifyRequest>({
    mutationFn: async (req) => {
      const { data } = await api.post<SampleClassifyResponse>(
        "/sample/classify",
        req,
      );
      return data;
    },
  });
}
